import styled from "styled-components";
export const ProgramWrapper = styled.div`
  background-color: #fff;
`;
